<style lang="less" scoped>
    .detail-from-input {
        width: 450px;
        margin: 10px 30px;
    }

    .detail-form-logo {
        margin: 16px 20px;
    }

    .margin-bt-10 {
        margin-bottom: 40px;
    }

    .detail-body-title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .upload-logo {
        width: 30%;
    }

    .app-card-style img {
        width: 350px;
        height: 160px;
        border-radius: 5px;
        cursor: pointer;
    }

    .app-card-style {
        display: flex;
        flex-direction: column;
    }

    .box {
        position: relative;
        width: 348px;
        height: 160px;
        overflow: hidden;
        border: 3px solid #4390df;
        border-radius: 6px;

    }

    .box:before {
        position: absolute;
        display: block;
        border-top: 20px solid #4390df;
        border-left: 20px solid transparent;
        right: 0;
        top: 0;
        content: "";
        z-index: 101;
    }

    .box:after {
        position: absolute;
        display: block;
        content: "\2714";
        top: -3px;
        right: 0;
        font-family: Glyphicons Halflings;
        font-size: 3pt;
        font-weight: normal;
        z-index: 102;
        color: #fff;
    }

    .img-div {
        margin: 10px 45px;
    }

    .detail-table {
        margin-top: 20px;
    }
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}               {{ detailForm.anNo }}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" class="detail-form">
                    <div class="detail-form-parent-div">
                        <div class="margin-bt-10">
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="公告名称" prop="anName">
                                    <el-input v-model="detailForm.anName" :disabled="editFlag" clearable size="small" oninput="value=value.replace(/[^'\a-\z\A-\Z0-9\u4E00-\u9FA5\.]/g,'')" placeholder="请输入公告名称" maxlength="20"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="公告内容" prop="content">
                                    <el-input v-model="detailForm.content" :disabled="editFlag" clearable size="small" placeholder="请输入100字以内公告内容" maxlength="100"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="启用时间" prop="startTime">
                                    <el-date-picker
                                        v-model="detailForm.startTime"
                                        style="width: 320px"
                                        type="date"
                                        size="small"
                                        value-format="yyyy-MM-dd 00:00:00"
                                        range-separator="-"
                                        :disabled="editFlag"
                                    ></el-date-picker>
                                </el-form-item>

                            </div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="结束时间" prop="endTimeType">
                                    <el-radio-group v-model="detailForm.endTimeType" :disabled="editFlag" @change="endTimeTypeChange">
                                        <el-radio label="01">具体时间</el-radio>
                                        <el-radio label="02">永久</el-radio>
                                    </el-radio-group> <br>
                                    <el-date-picker
                                        v-model="detailForm.endTime"
                                        style="width: 320px"
                                        type="date"
                                        size="small"
                                        value-format="yyyy-MM-dd 23:59:59"
                                        range-separator="-"
                                       :disabled="editFlag || endTimeFlag"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="跳转地址" prop="url">
                                    <el-input v-model="detailForm.url" :disabled='editFlag' clearable placeholder="请输入50字以内公告内容" size="small" maxlength="100"></el-input>
                                    若无跳转,则填入"/"
                                </el-form-item>

                            </div>


                        </div>
                        <div  class="margin-bt-10">
                        <div class="flex">
                                <div v-if="editFlag">
                                    <el-form-item class="detail-form-logo detail-body-title"  label="停用编辑">
                                        <el-radio-group v-model="detailForm.status" @click.native="statusChange($event)">
                                            <el-radio label="03">停用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                        </div>
                       </div>
                    </div>
                </el-form>

            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" :disabled="subDisabled" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                subDisabled:false,
                couponStatusName:'',
                endTimeType:'',
                editFlag: false, //表单是否编辑状态
                endTimeFlag:false,
                disabledVersion:true,
                pageTitle: '公告配置ID',
                pileVersionNo:'1',
                // 默认值设置
                detailForm: {
                    corpNo:'',
                },
                stationDetailForm: {}, //电站编号
                logoFile: null, //logo图标
                logoFileList: [], //logo预览文件
                dialogVisible: false, //app卡包样式弹窗
                selectFlag: '', //选中的卡包样式
                stationTableData: [], //绑定电站数据
                contractFile: null, //上传文件
                fileList: [], //上传文件预览地址
                dealerBankDtoList: [], //运营商收款账户数据
                dealerFileDtoList: [], //运营商table表单数据
                radio: '', //收款账号是否启用
                url: '', //请求数据的url地址
                ruleArr: [], //表单验证字段
                imgArr: [], //卡包样式数据列表
                fileRadio: '', //合同是否启用
                endRule:''
            }
        },
        methods: {
            endTimeTypeChange(val){
                if(val == '02'){
                    this.endTimeFlag = true
                    this.endRule = ''
                }else{
                    this.endTimeFlag = false
                    this.endRule = 'endTime'
                }
            },
            statusChange(e){
                console.log(e.target.tagName);
                    if (e.target.tagName === "INPUT") {
                        console.log(this.detailForm.status);
                        if (this.detailForm.status === "") {
                        this.detailForm.status = '03'
                        this.detailForm.statusName = '停用'
                        } else {

                        this.detailForm.status = JSON.parse(localStorage.getItem('announceDetail')).status
                        this.detailForm.statusName = this.detailForm.status == '02'?'启用':'待启用'
                    }
                }

            },
            changeVersionNo(val){
                this.detailForm.pileVersionNo = val
            },
            //是否为编辑模式
            init() {
                // this.url = this.$A.dealer.add;
                // if(this.$store.state.editId){this
                //     this.editFlag = true;
                //     this.pageTitle = "运营商编辑";
                //     this.getFormInfo();
                //     this.url = this.$A.dealer.edit;
                //     this.ruleArr = this.pageConfig.editRuleArr;
                //     this.getConfig();
                // }else{
                //     this.ruleArr = this.pageConfig.addRuleArr;
                // }
                if (localStorage.getItem('announceDetail')) {
                    this.editFlag = true;
                    this.detailForm = JSON.parse(localStorage.getItem('announceDetail'))
                    pageConfig.detailBreadCrumb[3].name = "公告栏配置";
                    this.detailForm.corpNo  =this.$store.state.corpNo
                    if(this.detailForm.endTime){
                        this.detailForm.endTimeType = '01'
                    }else{
                        this.detailForm.endTimeType = '02'
                    }
                    this.url = this.$A.coupon.announcementEdit;
                } else {
                    // this.detailForm.pileVersionNo = '1'
                    // this.pileVersionNo = '1'
                    // console.log(this.detailForm.pileVersionNo);
                    this.detailForm.corpNo  =this.$store.state.corpNo
                    // this.ruleArr = this.pageConfig.formRules;
                }
            },
            // 获取表单信息
            getFormInfo() {
                let _ = this;
                _.$H.post(_, _.$A.digitization.findPileFunctionByNo,{ pileTypeNo: _.detailForm.pileTypeNo}).then((res)=> {
                    _.detailForm = res.data.data;
                    if(!_.detailForm.pileVersionNo){
                        _.detailForm.pileVersionNo = '1'

                    }

                    _.logoFileList = [];
                    if (_.detailForm.pileImgUrl) {
                        let imgObj = {}
                        imgObj.name = 'pileImg';
                        imgObj.url = _.detailForm.pileImgUrl;
                        _.logoFileList.push(imgObj);
                    }
                    return
                });
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                    if(_.editFlag){
                        if(_.detailForm.status == '03'){
                            _.detailForm.statusName = '停用'
                        }
                        _.$H.post(_, _.url, _.detailForm).then(res => {
                            if(res.status === 200){
                            _.$router.push({
                                name: pageConfig.listRouter
                            });
                            }
                        })
                    }else {
                        if(_.detailForm.endTimeType == '01'&&!_.detailForm.endTime){
                       return _.$message.error('请选择具体结束时间')
                       }
                       if(_.detailForm.endTime&&new Date(_.detailForm.startTime)>new Date(_.detailForm.endTime)){
                        return _.$message.error('启用时间要小于结束时间')
                       }
                       delete _.detailForm.endTimeType
                        _.$H.post(_, _.$A.coupon.announcementAdd, _.detailForm).then(res => {
                            this.subDisabled = true
                            if(res.status === 200){
                                setTimeout(() => {
                                    this.subDisabled = false
                                }, 200);
                            _.$router.push({
                                name: pageConfig.listRouter
                            });
                            }
                        })
                    }
                        // _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
                    }
                })
                // this.$refs[formName].validateField(_.ruleArr, valid => {
                //     if (valid) {
                //         suc = false;
                //     }
                //     // num++;
                //     if (suc) {
                //         _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
                //     }
                // });
            },
            changeSelect (val) {
                this.$nextTick(() => {
                    console.log(this.$refs[val]);
                    this.detailForm[val] = this.$refs[val].selected.value
                    this.detailForm[`${val}Name`] = this.$refs[val].selected.label
                    console.log(this.detailForm);
                    // for (let i = 0; i < arr.length; i++) {
                    //     console.log(arr[i].label, i)
                    // console.log(arr[i].currentValue, i)
                    //     console.log(arr[i].currentLabel, i)
                    // }
                })
            },
            //上传logo图片
            toUploadLogoImg(param) {
                this.logoFile = param.file;
            },
            handleExceed(files, fileList){
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
                // console.log(fileList);
            },
            //清楚logo图片
            handleLogoRemove(file, fileList) {
                this.detailForm.pileImgUrl = '';
                this.logoFile = null;
            },
            //预览logo
            handleLogoPreview(file) {
                console.log(file);
            },
            //上传logo图片限制
            beforeAvatarUpload(file) {
                let logoType = false;
                if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/gif' || file.type === 'image/png') {
                    logoType = true;
                }
                const isLt1M = file.size / 1024 / 1024 < 1;

                if (!logoType) {
                    this.$message.error('上传logo图片只能是 jpg / jpeg / bmp / gif / png 格式!');
                }
                if (!isLt1M) {
                    this.$message.error('上传logo图片大小不能超过 1MB!');
                }
                return logoType && isLt1M;
            },
            //上传图片
            toUploadImg(item) {
                let _ = this;
                let fd = new FormData();
                fd.append('file', item.file)
                _.$H.postFormData(_, _.$A.digitization.pileFunctionImgUpload, fd).then(res => {
                    if(res.data.status === 200){
                        _.detailForm.url = res.data.data.viewPath || '';
                        _.$U.success("图片上传成功！")
                    }
                })
            },
            //删除上传图片
            handleRemove(file, fileList) {
                this.contractFile = null;
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            //删除附件前提示
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>
